import {efaPersonalDetails} from './efa-personal-details-de.i18n';

export const de = {
  efaPersonalDetails
};
